// lib
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'
import { call, delay } from 'redux-saga/effects'

// stores
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

export default function* updateSchemaSaga(schemaModel, surveys) {
  if (!staticStore.canUpdateDashboard) {
    return null
  }

  const updateSchemaURL = staticStore.urls.updateSchema
  if (!updateSchemaURL) {
    throw new Error('No "updateSchema" endpoint URL')
  }
  for (let i = 0; i < 5; i++) {
    try {
      const response = yield call(railsPostFetch, updateSchemaURL, {
        body: JSON.stringify({ schema: schemaModel.toJS(), surveys })
      })
      if (!response.ok) {
        throw new Error(response.error || 'Error updating block')
      }
      const body = yield call([response, 'json'])
      // debugged(body)
      if (body.status) {
        return body
      }
    } catch (error) {
      if (i < 4) {
        yield delay(1500)
      } else {
        throw error
      }
    }
  }
  throw new Error('Error updating block after multiple attempts')
}
